<div class="icon_header">
    <app-button-icon [imgUrl]="'assets/svg/plus-icon.svg'" [mat-dialog-close]="false"> </app-button-icon>
</div>
<div class='body'>
    <h4>Question {{data.qIndex}}</h4>
    <h3>Move category</h3>
    <app-form-select [list]="sections" (modelChange)="data.current=$event.id" [placeholderText]="'Category'"></app-form-select>
    <app-button-primary buttonContent="Move" [mat-dialog-close]="data.current"></app-button-primary>
    <app-button-secondary [isGreen]="false" [isText]="true" buttonText="Cancel" [mat-dialog-close]="false"></app-button-secondary>
</div>